import { CustomBillableProducts } from "@/admin/custom_products/CustomBillableProductsView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/custom_products")({
    component: CustomBillableProducts,
});
